// 高级研判 / 系统管理员 / 超级管理员，项目里多处特权能力都按这三个角色放行
export const PRIVILEGED_ROLE_LABELS = ["senior-survey", "sys-admin", "root"];

export const computeCharacterInfoVisibility = () => {
  try {
    const raw =
      localStorage.getItem("roles") || sessionStorage.getItem("roles");
    if (!raw) {
      localStorage.setItem("canViewCharacterInfo", JSON.stringify(false));
      return false;
    }
    const roles = typeof raw === "string" ? JSON.parse(raw) : raw;

    const privilegedLabels = new Set(PRIVILEGED_ROLE_LABELS);

    const hasPrivileged = Array.isArray(roles)
      ? roles
          .filter((r) => r && r.label && r.label !== "user")
          .some((r) => privilegedLabels.has(r.label))
      : false;

    localStorage.setItem("canViewCharacterInfo", JSON.stringify(hasPrivileged));
    return hasPrivileged;
  } catch (e) {
    localStorage.setItem("canViewCharacterInfo", JSON.stringify(false));
    return false;
  }
};

export const hasAnyRole = (roleLabels = []) => {
  try {
    const raw =
      localStorage.getItem("roles") || sessionStorage.getItem("roles");
    if (!raw) return false;

    const roles = typeof raw === "string" ? JSON.parse(raw) : raw;
    const allowedLabels = new Set(roleLabels);

    return Array.isArray(roles)
      ? roles.some((role) => role && allowedLabels.has(role.label))
      : false;
  } catch (e) {
    return false;
  }
};

// 标签管理（节点标签的增 / 改 / 删）只对这三个角色开放。
// 覆盖：正式画布右键菜单、临时画布右键菜单、画布右侧菜单、AI 画布右键菜单、标签管理页。
export const canManageTags = () => hasAnyRole(PRIVILEGED_ROLE_LABELS);

// 头部头像下拉里那个扁平的「标签管理」入口（指向标签模板列表 /permissions/labelList）只给高级研判看。
// 注意它和「权限管理 → 标签管理」指向同一个路由，两者靠角色互斥（见 homeheader.vue）。
export const canAccessLabelTemplateMenu = () => hasAnyRole(["senior-survey"]);

export const getPrimaryRoleDisplayName = (roles) => {
  try {
    let roleList = roles;
    if (!Array.isArray(roleList)) {
      const raw =
        localStorage.getItem("roles") || sessionStorage.getItem("roles");
      roleList = raw ? JSON.parse(raw) : [];
    }

    const primaryRole = roleList
      .filter((role) => role && role.label)
      .slice()
      .sort((left, right) => (right.weight || 0) - (left.weight || 0))[0];

    if (!primaryRole) return "";
    if (["sys-admin", "root"].includes(primaryRole.label)) {
      return "系统管理员";
    }
    return primaryRole.value || "";
  } catch (e) {
    return "";
  }
};

// 添加公群监控入口只对高级研判 / 系统管理员 / 超级管理员开放。
export const canAddTgGroupMonitor = () => hasAnyRole(PRIVILEGED_ROLE_LABELS);

// 人物调查（右键菜单入口）只对内部分析师及以上开放：
// 与后端 prefill / add 的角色闸一致（其余角色调用会 403 permission.not）
export const canUsePersonInvestigation = () =>
  hasAnyRole(PRIVILEGED_ROLE_LABELS);

export const canAccessTgFeatures = () => {
  try {
    const raw =
      localStorage.getItem("roles") || sessionStorage.getItem("roles");
    if (!raw) return false;

    const roles = typeof raw === "string" ? JSON.parse(raw) : raw;
    return Array.isArray(roles)
      ? roles.some(
          (role) => role && role.label && role.label !== "initial_role",
        )
      : false;
  } catch (e) {
    return false;
  }
};
